import {Label} from "../../../basic/label";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "../../../basic/select";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface RoleSelectorProps {
    role: string;
    onRoleChange: (role: string) => void;
    disabled?: boolean;
    isUniversity?: boolean;
}

export function RoleSelector({role, onRoleChange, disabled = false, isUniversity = false}: RoleSelectorProps) {
    const {t} = useTranslationWithKeys();

    return (
        <div className="space-y-2">
            <Label htmlFor="userRole">{t('common.form.role')}</Label>
            <Select
                value={role}
                onValueChange={onRoleChange}
                disabled={disabled}
            >
                <SelectTrigger id="userRole">
                    <SelectValue placeholder={t('common.team.selectRole')}/>
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="user">{t('common.role.user')}</SelectItem>
                    <SelectItem value="admin">{t('common.role.admin')}</SelectItem>
                    {isUniversity && (
                        <SelectItem value="student">{t('common.role.student')}</SelectItem>
                    )}
                </SelectContent>
            </Select>
            <p className="text-muted-foreground text-sm">
                {t('common.team.adminDescription')}
            </p>
        </div>
    );
}